import { useMediaQuery } from '@mui/material';

const useIsMobile = () =>
  useMediaQuery((theme: any) => theme.breakpoints.down('sm'));

export default useIsMobile;
